<div class="chips-header">
  <p-checkbox
    class="haslocation-checkbox"
    [ngModel]="hasLocation"
    (onChange)="
      hasLocationChange.emit($event.checked); hasLocation = $event.checked
    "
    binary="true"
    inputId="enabled"
  >
  </p-checkbox>
  <i class="pi pi-map-marker"></i>
  <label for="enabled">Enabled</label>

  @if (type() === types.origin) {
    <span> Place of receipt / Origin Location </span>
    <span class="chips-header__rule"></span>
  }
  @if (type() === types.destination) {
    <span> Destination Location / Place of delivery </span>
  }
</div>
<div
  class="chips-box"
  [class.expanded]="isExpanded()"
  [class.hidden]="!hasLocation"
>
  <div class="chips-wrapper">
    @if (locations?.length) {
      <p-autocomplete
        [multiple]="true"
        [typeahead]="false"
        [(ngModel)]="locations"
        (onUnselect)="removeElement($event)"
      >
        <ng-template let-item #selecteditem>
          <div
            [class.currently-edited]="currentEditedLocationId === item.id"
            (mousedown)="isExpanded() ? editLocation(item) : false"
          >
            @if (type() === types.origin) {
              <div>
                @if (item.inlandHaulage) {
                  <span>
                    {{ item.inlandHaulage }}
                    @if (!item.latitude) {
                      <i
                        class="pi pi-exclamation-triangle"
                        pTooltip="This entry was not linked with Google Maps zip-code and/or coordinates. Inland haulage rate(s) may not be applied.            "
                        tooltipPosition="right"
                      >
                      </i>
                    }
                    <i class="pi pi-arrow-right"></i>
                  </span>
                }
                @if (item.location) {
                  <app-location-icon [kind]="item.location.kind">
                  </app-location-icon>
                  <strong>{{ item.location.name }}</strong>
                } @else {
                  <i
                    class="pi pi-exclamation-triangle"
                    pTooltip="No origin location is set, so no rates can be applied to this place of receipt. Pick one below."
                    tooltipPosition="right"
                  >
                  </i>
                  <strong class="location-missing">Location missing</strong>
                }
              </div>
            }
            @if (type() === types.destination) {
              <div>
                @if (item.location) {
                  <app-location-icon [kind]="item.location.kind">
                  </app-location-icon>
                  <strong>{{ item.location.name }}</strong>
                } @else {
                  <i
                    class="pi pi-exclamation-triangle"
                    pTooltip="No destination location is set, so no rates can be applied to this place of delivery. Pick one below."
                    tooltipPosition="right"
                  >
                  </i>
                  <strong class="location-missing">Location missing</strong>
                }
                @if (item.inlandHaulage) {
                  <span>
                    <i class="pi pi-arrow-right"></i>
                    {{ item.inlandHaulage }}
                    @if (!item.latitude) {
                      <i
                        class="pi pi-exclamation-triangle"
                        pTooltip="This entry was not linked with Google Maps zip-code and/or coordinates. Inland haulage rate(s) may not be applied.            "
                        tooltipPosition="right"
                      >
                      </i>
                    }
                  </span>
                }
              </div>
            }
          </div>
        </ng-template>
      </p-autocomplete>
    }
    @if (locations?.length && !isExpanded()) {
      <button
        type="button"
        class="chips-add"
        data-cy="chips-add"
        aria-label="Add location"
      >
        <i class="pi pi-plus"></i>
      </button>
    }
  </div>
  <div class="add-form">
    <div class="add-form__row">
      @if (type() === types.destination) {
        <div class="add-form__field">
          <span class="add-form__label form-control-label required">
            Destination Location
          </span>
          <app-location-or-group-select
            data-cy="location-select-destination"
            [required]="true"
            [selection]="locationGroup ?? location"
            [showGroups]="!currentEditedLocationId"
            [filterGroupsByKind]="true"
            [locationKindFilter]="locationKindFilter()"
            [locationKindFilterOptions]="locationKindFilterOptions()"
            (selectionChange)="onLocationChange($event)"
          >
          </app-location-or-group-select>
        </div>
        <i class="pi pi-arrow-right d-none d-md-inline-block"></i>
      }
      <div class="add-form__field">
        <span class="add-form__label">{{
          type() === types.origin ? "Place of receipt" : "Place of delivery"
        }}</span>
        <app-place-autocomplete
          dataCy="quote-inland"
          [value]="inlandHaulage"
          placeholder="Inland"
          (valueChange)="inlandHaulage = $event"
          (placeSelect)="onPlaceSelect($event)"
          (pendingChange)="placePending = $event"
        ></app-place-autocomplete>
      </div>
      @if (type() === types.origin) {
        <i class="pi pi-arrow-right d-none d-md-inline-block"></i>
        <div class="add-form__field">
          <span class="add-form__label form-control-label required">
            Origin Location
          </span>
          <app-location-or-group-select
            data-cy="location-select-origin"
            [required]="true"
            [selection]="locationGroup ?? location"
            [showGroups]="!currentEditedLocationId"
            [filterGroupsByKind]="true"
            [locationKindFilter]="locationKindFilter()"
            [locationKindFilterOptions]="locationKindFilterOptions()"
            (selectionChange)="onLocationChange($event)"
          >
          </app-location-or-group-select>
        </div>
      }
      <div
        class="add-form__actions"
        [class.edit-mode]="!!currentEditedLocationId"
      >
        @if (!!currentEditedLocationId) {
          <button
            pButton
            severity="primary"
            class="location-save"
            [disabled]="placePending"
            (click)="saveInland()"
          >
            <i class="pi pi-check"></i>
          </button>
        }
        @if (!currentEditedLocationId) {
          <button
            pButton
            severity="primary"
            data-cy="location-add"
            class="location-add"
            [disabled]="!(location || locationGroup) || loading || placePending"
            (click)="addElement()"
          >
            <i class="pi pi-check"></i>
          </button>
        }
      </div>
    </div>
  </div>
</div>
